export const SERVICE_STORAGE_KEY = 'ttsds-service'

let syncedServiceData = {
  centre: {
    abn: "", 
    address: "", 
    addressLine1: "", 
    addressLine2: "", 
    contactPerson: "", 
    email: "", 
    name: "", 
    phone: "", 
    postcode: "", 
    seNumber: "", 
    state: "",
    suburb: ""
  },
  educatorUser: {
    userFirstName: "",
    userLastName: "",
    userPreferredName: "",
    userEmail: "",
    userEmailConfirmation: "",
    userMobile: ""
  },
  registerCentre: {
    abn: "", 
    address: "", 
    addressLine1: "", 
    addressLine2: "", 
    contactPerson: "", 
    email: "", 
    name: "", 
    phone: "", 
    postcode: "", 
    seNumber: "", 
    state: "",
    suburb: ""
  }
}

if(sessionStorage.getItem(SERVICE_STORAGE_KEY)) {
  syncedServiceData = JSON.parse(sessionStorage.getItem(SERVICE_STORAGE_KEY));
}

const state = Object.assign(syncedServiceData);

const actions = {
  SET_SERVICE({ commit }, service) {
    commit("SET_SERVICE", service);
  },
  CLEAR_SERVICE({ commit }) {
    commit("CLEAR_SERVICE");
  },
  SET_REGISTER_SERVICE({ commit }, data) {
    commit("SET_REGISTER_SERVICE", data);
  },
  CLEAR_REGISTER_SERVICE({ commit }) {
    commit("CLEAR_REGISTER_SERVICE");
  },
  SAVE_EDUCATOR_FIELD({ commit }, data) {
    commit("SAVE_EDUCATOR_FIELD", data);
  },
  CLEAR_EDUCATOR({ commit }) {
    commit("CLEAR_EDUCATOR");
  }
}

const mutations = {
  SET_SERVICE(state, service) {
    state.centre = service;
  },
  CLEAR_SERVICE(state) {
    state.centre = {};
  },
  SET_REGISTER_SERVICE(state, service) {
    state.registerCentre = service;
  },
  CLEAR_REGISTER_SERVICE(state) {
    state.registerCentre = {};
  },
  SAVE_EDUCATOR_FIELD(state, data) {
    state.educatorUser = data;
  },
  CLEAR_EDUCATOR (state) {
    state.educatorUser = {
      userFirstName: "",
      userLastName: "",
      userPreferredName: "",
      userEmail: "",
      userEmailConfirmation: "",
    };
  }
}

const getters = {
  getService(state) {
    return state.centre;
  },
  getRegisterService(state) {
    return state.registerCentre;
  },
  getServiceFieldByKey: state => key => {
    return state.centre[key];
  },
  getRegisterSeNumber(state) {
    return state.registerSeNumber;
  },
  getRegisterEmail(state) {
    return state.registerEmail;
  },
  getEducatorUser(state) {
    return state.educatorUser;
  },
  getEducatorEmail(state) {
    return state.educatorUser.userEmail;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
